// extracted by mini-css-extract-plugin
export default {"transactionpopup":"Popup_transactionpopup__cVnor","popupcontent":"Popup_popupcontent__YLnfF","closebtn":"Popup_closebtn__HKvmz","popupButton":"Popup_popupButton__olLLg"};